import type { Menu, MenuEntry } from "./MenuBar";

// D87 — Reine Merge-Logik der geteilten Editor-Menüleiste (EditorMenuStrip). Aus der Komponente getrennt,
// damit sie ohne React-/Projekt-Abhängigkeiten unit-testbar bleibt (type-only Import von MenuBar).

/**
 * Menüs mehrerer Quellen (Shell + Editor) nach Label zusammenführen. Die ERSTE Erwähnung eines Labels
 * bestimmt seine Position (⇒ Reihenfolge „Datei | Bearbeiten | Ansicht | Level", wenn Shell-Datei zuerst
 * und Shell-Level zuletzt übergeben wird); gleichnamige Menüs werden mit einem Trenner verkettet. Menüs
 * ohne Einträge werden übersprungen (kein leeres Dropdown).
 */
export function mergeMenus(...groups: Menu[][]): Menu[] {
  const order: string[] = [];
  const byLabel = new Map<string, MenuEntry[]>();
  for (const group of groups) {
    for (const menu of group) {
      if (!menu.entries.length) continue;
      let acc = byLabel.get(menu.label);
      if (!acc) {
        acc = [];
        byLabel.set(menu.label, acc);
        order.push(menu.label);
      } else {
        acc.push({ separator: true });
      }
      acc.push(...menu.entries);
    }
  }
  return order.map((label) => ({ label, entries: byLabel.get(label)! }));
}
